import React, { useEffect, useRef, useState } from "react";
// react admin
import { useGetIdentity, useGetList, useUpdate } from "react-admin";
// mui
import {
  Card,
  CardContent,
  Typography,
  Box,
  Switch,
  FormControlLabel,
  Skeleton,
} from "@mui/material";
// loader
import { Loader } from "../../Loader";
import { initializeWebSocket, sendWebSocketMessage } from "../../../Provider/socket";

const settingColumns = [
  [
    { key: "isBalanceCapped", label: "Balance Capped" },
    { key: "isLuckyWheelAvailable", label: "Lucky Wheel" },
    { key: "isLeaderBoardAvailable", label: "Leader Board" },
  ],
  [
    { key: "isHourlyBonusWheelAvailable", label: "Hourly Bonus Wheel" },
  ],
];
const settingFields = settingColumns.flat();

export const GameSettings = () => {
  const { data: identity, isPending } = useGetIdentity();
  const [update, { isLoading }] = useUpdate();
  const { data: gameSetting } = useGetList("GameSettings", {
    pagination: { page: 1, perPage: 10 },
    sort: { field: "createdAt", order: "DESC" },
  });

  const [settings, setSettings] = useState({});
  const isSuperUser = identity?.userRoleName === "Super-User";
  useEffect(() => {
    const socket = initializeWebSocket((data) => {
    });
  }, []);
  useEffect(() => {
    if (gameSetting?.length) {
      const [first] = gameSetting;
      const normalized = settingFields.reduce(
        (acc, { key }) => ({ ...acc, [key]: Boolean(first[key]) }),
        { id: first.id }
      );
      setSettings(normalized);
    }
  }, [gameSetting]);

  const handleToggle = (field) => (event) => {
    const value = event.target.checked;

    // Optimistic UI update
    setSettings((prev) => ({ ...prev, [field]: value }));

    update("GameSettings", {
      id: settings.id,
      data: { [field]: value },
    },
    {
      onSuccess: (updated) => {
        // emit socket event (mimics your example shape)
        safeSendWS("message", {
          eventName: "game_settings",
          action: "toggle",
          field,
          value,
          settingsId: settings.id,
          // include who changed it (best-effort)
          updatedBy: identity?.id || identity?.userId || identity?.fullName || "unknown",
          // optionally include the updated RA record
          updatedRecord: updated,
          timestamp: new Date().toISOString(),
        });
      }
    }
    );
  };
  const safeSendWS = (channel, payloadObj) => {
    try {
      if (typeof sendWebSocketMessage === "function") {
        sendWebSocketMessage(channel, JSON.stringify(payloadObj));
      }
    } catch (_) {}
  };
  return (
    <React.Fragment>
      {isLoading && <Loader />}
      {isPending ? (
        <Card
          variant="outlined"
          sx={{
            mt: 2,
            backgroundColor: "#242424",
            borderRadius: "8px",
          }}
        >
          <CardContent>
            <Skeleton
              width="100%"
              height={100}
              sx={{
                mt: 1,
                background: "#fff",
              }}
            />
            <Skeleton
              width="50%"
              height={40}
              sx={{
                mt: 1,
                background: "#fff",
              }}
            />
            <Skeleton
              width="50%"
              height={40}
              sx={{
                mt: 1,
                background: "#fff",
              }}
            />
            <Skeleton
              width="50%"
              height={40}
              sx={{
                mt: 1,
                background: "#fff",
              }}
            />
            <Skeleton
              width="50%"
              height={40}
              sx={{
                mt: 1,
                background: "#fff",
              }}
            />
          </CardContent>
        </Card>
      ) : (
        <Card
          variant="outlined"
          sx={{
            mt: 2,
            backgroundColor: "#242424",
            borderRadius: "8px",
          }}
        >
          <CardContent>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography variant="body2" sx={{ color: "#FFF", fontSize: 18 }}>
                Game Settings
              </Typography>
              <Box
                sx={{
                  backgroundColor: "rgba(255, 215, 0, 0.20)",
                  padding: "8px",
                  borderRadius: "4px",
                }}
              >
                <img
                  src="/Assets/Icons/user-account.svg"
                  alt="User Icon"
                  style={{ width: 24, height: 24 }}
                />
              </Box>
            </Box>

            {isSuperUser && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: 4,
                  mt: 2,
                }}
              >
                {settingColumns.map((column, idx) => (
                  <Box
                    key={idx}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 3.5,
                      flex: 1,
                    }}
                  >
                    {column.map(({ key, label }) => (
                      <Box key={key}>
                        <Typography
                          variant="h6"
                          sx={{ color: "#999", fontSize: 14 }}
                        >
                          {label}
                        </Typography>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={settings[key] || false}
                              onChange={handleToggle(key)}
                              color="primary"
                              inputProps={{ "aria-label": `${label} Toggle` }}
                            />
                          }
                        />
                      </Box>
                    ))}
                  </Box>
                ))}
              </Box>
            )}
          </CardContent>
        </Card>
      )}
    </React.Fragment>
  );
};
